import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Button from '../../../../../../components/global/Button';
import { UPDATE_ROSTER_IDENTITY_MODAL } from '../../../../../../constants/modals';
import InputGroup from '../../../../../../components/global/InputGroup';
import SearchIcon from '../../../../../../components/icons/SearchIcon';
import UserAddIcon from '../../../../../../components/icons/UserAddIcon';
import ImportIcon from '../../../../../../components/icons/ImportIcon';
import { ADDRESS_BOOOK_CSV_UPLOAD_MODAL } from '../AddressBookCSVUpload';
import useWaldogramsForBusinessEvent from '../../../../services/analytics/useWaldogramsForBusinessEvent';
import Select from '../../../../../../components/global/Select';
import useAccountCardCreations from '../../../AccountCards/hooks/useAccountCardCreations';
import useBasename from '../../../../../../components/routing/useBasename';
import DraftWaldogramsIcon from '../../../../../../components/icons/DraftWaldogramsIcon';

const propTypes = {
  onFilterUpdate: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
  onSelectableToggle: PropTypes.func,
  selectable: PropTypes.bool,
  canSelect: PropTypes.bool,
};

const AccountAddressBookHeader = ({
  onFilterUpdate,
  filter,
  openModal,
  onSelectableToggle,
  selectable,
  canSelect,
}) => {
  const history = useHistory();
  const basename = useBasename();
  const { sentAccountCards } = useAccountCardCreations({ limit: 1 });
  const [searchQuery, setSearchQuery] = useState('');
  const trackEvent = useWaldogramsForBusinessEvent();

  const onSubmit = event => {
    event.preventDefault();

    if (searchQuery !== filter.searchQuery) {
      onFilterUpdate({ searchQuery, page: 0, offset: 0 });
    }
  };

  return (
    <div className="address-book-header-wrapper">
      <div className="address-book-header">
        <form onSubmit={onSubmit} className="address-book-search-form">
          <InputGroup
            id="address-book-search"
            name="addressBookSearch"
            type="text"
            label="Search your contacts"
            placeholder="Search your contacts"
            labelSrOnly
            addon={<SearchIcon color="#ced6e4" size={14} />}
            value={searchQuery}
            size="sm"
            onChange={event => {
              setSearchQuery(event.target.value);
            }}
          />

          <Button type="submit" btnSize="sm">
            Search
          </Button>
        </form>

        <div className="address-book-header-actions">
          <Button
            btnStyle="link"
            className="d-flex align-items-center"
            onClick={() => {
              openModal(UPDATE_ROSTER_IDENTITY_MODAL, {
                modalTitle: 'Create Contact',
              });
            }}
          >
            <UserAddIcon color="#0d84fe" size={14} className="mr-1" />{' '}
            <span className="d-none d-md-inline-block">Create contact</span>
            <span className="d-inline-block d-md-none">Create</span>
          </Button>

          <Button
            onClick={() => {
              openModal(ADDRESS_BOOOK_CSV_UPLOAD_MODAL);
              trackEvent({
                action: 'CSV Upload',
                label: 'Address Book',
              });
            }}
            btnStyle="link"
            className="d-flex align-items-center ml-1"
          >
            <ImportIcon color="#0d84fe" size={14} className="mr-1" />
            <span className="d-none d-md-inline-block">Import contacts</span>
            <span className="d-inline-block d-md-none">Import</span>
          </Button>

          {canSelect && onSelectableToggle && (
            <Button
              btnStyle="link"
              className="d-flex align-items-center ml-1"
              onClick={onSelectableToggle}
            >
              {selectable ? 'Cancel selection' : 'Send Waldograms'}
            </Button>
          )}
        </div>
      </div>
      {sentAccountCards?.total > 0 && (
        <div className="d-flex flex-column align-items-center align-items-md-end">
          <Button
            btnStyle="link"
            onClick={() => history.push(`/app/${basename}/account/cards/list`)}
          >
            <DraftWaldogramsIcon color="#0d84fe" size={14} className="mr-1" />{' '}
            View previously sent Waldograms
          </Button>
        </div>
      )}
      <div className="d-flex flex-column align-items-end">
        <Select
          id="contacts-per-page"
          name="contactsPerPage"
          label="Contacts per page"
          className="d-inline-block my-1"
          value={filter.limit}
          onChange={event => {
            onFilterUpdate({ limit: event.target.value });
          }}
          size="sm"
        >
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={250}>250</option>
          <option value={500}>500</option>
          <option value={1000}>1000</option>
          <option value={9999}>All</option>
        </Select>
      </div>
    </div>
  );
};

AccountAddressBookHeader.propTypes = propTypes;

export default AccountAddressBookHeader;
